import React from 'react'
import {
    Skeleton,
    TableRow,
    TableCell,
} from "@mui/material";

const CartItemRows = () => {
    return [...Array(3)].map((_, index) => (
        <TableRow key={index}>
            <TableCell><Skeleton variant="rectangular" width={80} height={80} /></TableCell>
            <TableCell><Skeleton variant="text" width={40} /></TableCell>
            <TableCell><Skeleton variant="text" width={80} /></TableCell>
            <TableCell><Skeleton variant="text" width={60} /></TableCell>
            <TableCell><Skeleton variant="text" width={60} /></TableCell>
            <TableCell><Skeleton variant="text" width={80} /></TableCell>
            <TableCell><Skeleton width={60} /></TableCell>
        </TableRow>
    ));
}

export default CartItemRows